import {
    IServicesNomenclatures,
    IServicesNomenclaturesListItem, ServicesNomenclaturesResponseType
} from "@/entity/servicesNomenclature/services.nomenclature.types";

export default class ServicesNomenclature implements IServicesNomenclatures {
    total: number;
    data: IServicesNomenclaturesListItem[] = [];
    constructor(data: ServicesNomenclaturesResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}